import { manifesto } from "@/data/site";
import { Reveal } from "./motion";

export const Manifesto = () => (
  <section
    id="why"
    data-testid="why-section"
    className="relative z-10 bg-[#1c1c1c] py-24 sm:py-32 border-y border-white/5"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-3xl mb-16">
        <p className="text-xs tracking-[0.3em] uppercase text-[#FF4500] font-bold mb-4">
          Why Duke Summers
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
          A standard, not just a service
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#3d3d3d] border border-[#3d3d3d]">
        {manifesto.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.08}>
            <div
              data-testid={`manifesto-${m.n}`}
              className="relative bg-[#303030] p-8 sm:p-12 h-full overflow-hidden group"
            >
              <span className="font-display font-extrabold text-6xl leading-none text-outline absolute top-6 right-6 select-none opacity-20 transition-opacity">
                {m.n}
              </span>
              <div className="relative z-10 max-w-sm">
                <h3 className="font-display font-bold text-2xl tracking-tight">
                  {m.title}
                </h3>
                <p className="mt-4 text-neutral-400 leading-relaxed">{m.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
